import React from 'react'
import { Tooltip } from 'components'
import classnames from 'classnames'
import { FaInfoCircle } from 'react-icons/fa'
import styled from 'styled-components'

const InfoTooltip = ({ text, className, ...rest }) => {
  return (
    <Tooltip text={text}>
      <InfoCircle className={classnames('edit-mode', className)} {...rest} />
    </Tooltip>
  )
}

export const InfoCircle = styled(FaInfoCircle)`
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
`

export default InfoTooltip
